import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { DataImportsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createDataImport = (data): any => action(types.CREATE_DATA_IMPORT_REQUESTED, data);

export const updateDataImport = (data): any => action(types.UPDATE_DATA_IMPORT_REQUESTED, data);

export const deleteDataImport = (dataImportId): any => action(types.UPDATE_DATA_IMPORT_REQUESTED, dataImportId);

export const getDataImport = (dataImportId): any => action(types.GET_DATA_IMPORT_REQUESTED, dataImportId);

export const getAllDataImports = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_DATA_IMPORTS_REQUESTED, {
  pagination,
  compile,
});

export const selectDataImport = (dataImportId): any => action(types.SELECT_DATA_IMPORT_REQUESTED, {
  currentDataImportId: dataImportId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createDataImportPending: (payload): any => action(types.CREATE_DATA_IMPORT_PENDING, payload),
  createDataImportSuccess: (response): any => {
    const currentDataImport = response.entities.dataImports[response.result];
    // history.push(`/payment/${currentDataImport.paymentCollection.id}/review`);
    return action(types.CREATE_DATA_IMPORT_SUCCESS, {
      dataImportsById: response.entities.dataImports,
      currentDataImportId: response.result,
    });
  },
  createDataImportFailed: (error): any => action(types.CREATE_DATA_IMPORT_FAIL, { backendErrors: error }),
  updateDataImportPending: (payload): any => action(types.UPDATE_DATA_IMPORT_PENDING, payload),
  updateDataImportSuccess: (response): any => action(types.UPDATE_DATA_IMPORT_SUCCESS, {
    dataImportsById: response.entities.dataImports,
    currentDataImportId: response.result,
  }),
  updateDataImportFailed: (error): any => action(types.UPDATE_DATA_IMPORT_FAIL, { backendErrors: error }),
  deleteDataImportPending: (): any => action(types.UPDATE_DATA_IMPORT_PENDING, {}),
  deleteDataImportSuccess: (response, userId): any => {
    localStorage.set(userId, { currentDataImportId: null });
    history.push('/dataImports');

    return action(types.DELETE_DATA_IMPORT_SUCCESS, {
      currentDataImportId: response,
    });
  },
  getDataImportPending: (): any => action(types.GET_DATA_IMPORT_PENDING, {}),
  getDataImportSuccess: (response): any => action(types.GET_DATA_IMPORT_SUCCESS, {
    dataImportsById: response.entities.dataImports,
    currentDataImportId: response.result,
  }),
  getDataImportFailed: (error): any => action(types.GET_DATA_IMPORT_FAIL, { backendErrors: error }),
  deleteDataImportFailed: (error): any => action(types.UPDATE_DATA_IMPORT_FAIL, { backendErrors: error }),
  getAllDataImportsPending: (pagination): any => action(types.GET_ALL_DATA_IMPORTS_PENDING, { pagination }),
  getAllDataImportsSuccess: (response, meta): any => action(types.GET_ALL_DATA_IMPORTS_SUCCESS, {
    dataImportsById: response.entities.dataImports,
    dataImportIds: response.result,
    meta,
  }),
  getAllDataImportsFailed: (error): any => action(types.GET_ALL_DATA_IMPORTS_FAIL, { backendErrors: error }),
};

export default null;
